import { ViewDataRow, ViewGoalCommitment, ViewRow } from '../../core';

export function dateTransformRows(rows: ViewRow[] | null): void {
    _dateTransformRowsA(rows);
    _dateTransformRowsB(rows);
}

export function _dateTransformRowsA(rows: ViewRow[] | null): void {
    const flatten = (rows_: ViewRow[] | null, arr: ViewDataRow[]): void => {
        rows_?.reduce<ViewDataRow[]>((p, c) => {
            p.push(c.row);
            flatten(c.children, p);
            return p;
        }, arr);
    };

    const f: ViewDataRow[] = [];
    flatten(rows, f);

    f.forEach((row) => {
        const pd = row.individual ?? row.peopleDetail;

        pd.startDateDataRange =
            pd?.startDateDataRange == null
                ? null
                : new Date(pd.startDateDataRange);

        pd.endDateDataRange =
            pd?.endDateDataRange == null ? null : new Date(pd.endDateDataRange);

        pd.createdOn = pd?.createdOn == null ? null : new Date(pd.createdOn);
    });
}

export function _dateTransformRowsB(rows: ViewRow[] | null): void {
    const flatten = (
        rows_: ViewRow[] | null,
        arr: ViewGoalCommitment[],
    ): void => {
        rows_?.reduce<ViewGoalCommitment[]>((p, c) => {
            if (c.row?.assessedGoalCommitments != null) {
                p.push(...c.row.assessedGoalCommitments);
            }
            if (c.row?.excludedGoalCommitments != null) {
                p.push(...c.row?.excludedGoalCommitments);
            }
            flatten(c.children, p);
            return p;
        }, arr);
    };

    const f: ViewGoalCommitment[] = [];
    flatten(rows, f);

    f.forEach((gc) => {
        if (gc.data == null) {
            return;
        }
        gc.data.goalStartDate =
            gc.data?.goalStartDate != null
                ? new Date(gc.data?.goalStartDate)
                : null;
    });
}
